// react
import { useMemo } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { daDK, enUS } from '@mui/x-data-grid/locales';

/**
 * Hook that returns the appropriate DataGrid locale text based on the current language selection.
 * Defaults to Danish (daDK) if language is 'dk', otherwise returns English (enUS).
 *
 * @returns {Object} MUI DataGrid locale text object
 */
export const useDatagridLocaleText = () => {
  const { i18n } = useTranslation();

  const localeText = useMemo(() => {
    const currentLanguage = i18n.language;

    if (currentLanguage === 'dk') {
      return daDK.components.MuiDataGrid.defaultProps.localeText;
    }

    return enUS.components.MuiDataGrid.defaultProps.localeText;
  }, [i18n.language]);

  return localeText;
};
